import Layout from './layout';

// export { default as Header } from './header';
// export { default as Footer } from './footer';

export default Layout;
